"use client";
import MuxPlayer from "@mux/mux-player-react/lazy";

type MuxPlayerProps = {
  thumbnailTime?: number;
  playbackId?: string;
  metadata?: {};
  orientation?: "horizontal" | "vertical";
};

export function MuxVideoPlayer({
  thumbnailTime,
  playbackId = "1J3Y7p02Hv1U5F3z02Irtl4VVEjrSzurAjvCB1ZTu01IVs",
  metadata = {},
  orientation = "vertical",
}: MuxPlayerProps) {
  const aspectRatio = orientation === "vertical" ? 9 / 16 : 16 / 9;

  return (
    <MuxPlayer
      loading="viewport"
      playbackId={playbackId}
      metadata={metadata}
      streamType="on-demand"
      thumbnailTime={thumbnailTime}
      style={{ aspectRatio: aspectRatio }}
    />
  );
}
